/* eslint-disable lines-between-class-members */
import { Expose, Transform } from 'class-transformer';
import { IsBoolean, IsDate, IsString } from 'class-validator';
import { Timestamp } from 'firebase/firestore';
import { isTimestamp } from '../utils/decorators';

export class Person {
  @IsString()
  readonly id: string;

  @IsString()
  readonly name: string;

  @IsString()
  readonly email: string;

  @Expose({ name: 'identity_number' })
  @IsString()
  @Transform((params) => params.value && params.value.replace(/[^0-9xX]/g, ''), {
    toPlainOnly: true,
  })
  readonly identityNumber?: string;

  @Expose({ name: 'phone_number' })
  @IsString()
  readonly phoneNumber?: string;

  @Expose({ name: 'photo_url' })
  @IsString()
  readonly photoUrl?: string | null;

  @Expose({ name: 'is_disabled' })
  @IsBoolean()
  readonly isDisabled?: boolean;

  @Expose({ name: 'date_of_birth' })
  /** Handle transform to normalize old data */
  @Transform(
    ({ value }: { value: Timestamp | string }) => {
      if (isTimestamp(value)) {
        return new Timestamp((value as Timestamp).seconds, (value as Timestamp).nanoseconds).toDate();
      }

      return value ? new Date(value as string) : undefined;
    },
    { toClassOnly: true }
  )
  @IsDate()
  readonly dateOfBirth?: Date;

  @IsString()
  @Expose({ name: 'social_name' })
  readonly socialName?: string;

  constructor(init?: Person | Partial<Person>) {
    this.id = init?.id!;
    this.name = init?.name!;
    this.email = init?.email!;
    this.identityNumber = init?.identityNumber;
    this.phoneNumber = init?.phoneNumber;
    this.photoUrl = init?.photoUrl;
    this.dateOfBirth = init?.dateOfBirth;
    this.isDisabled = init?.isDisabled;
    this.socialName = init?.socialName;
  }
}

export default Person;
